module.exports = __webpack_public_path__ + "img/news_01.a4978f6c.jpg";